import React from 'react'
import * as R from 'ramda'
import omit from 'lodash/omit'
import { createSelector } from 'reselect'
import qs from 'query-string'
import get from 'lodash/get'
import has from 'lodash/has'
import isObject from 'lodash/isObject'
import { mapissuesModule } from '@infotech/4sides-front-core'
import {
  mapissuesReducers,
  issuesApiActions,
  baseActions,
  URL,
  ISSUES_SCHEMA_NAME,
} from '@infotech/mapissues'
import createFiltersConfig from '@infotech/filters'
import {
  defaulCrudConfigMaker,
  getFullFilterFieldsConf,
  getComputedQuery,
  getCheckedRows,
} from '@infotech/crud'

import {
  getFormConfig,
  getFilterConfig,
  getViewConfig,
  getGridConfig,
  getAllColumns,
  getAllFilters,
  issuesViewList,
  defaultFilterList,
  defaultFormListEdit,
  defaultFormList,
} from './fieldsConf'
import filterFormFields from './filterFormFields'
import { getCreateFailMessage } from './getFailMessage'
import { rightWidgetsConfig as rightWidgetsConfiguration } from '../widgets'
import CRUDform from './components/Form'
import CreateButton from './components/CreateButton'
import { EditButtonConfig, ReadEditButtonConfig } from './components/EditButton'

const { defaultModuleConfig, CRUD_PATH } = mapissuesModule.config

const filtersConfig = createFiltersConfig({
  filterName     : `filters`,
  savedFiltersUrl: `/user-filters/issues/filters`,
})

const defaultFilterConfig = createFiltersConfig({
  filterName     : `defaultFilter`,
  savedFiltersUrl: `/user-filters/issues/filters/default`,
  useRSQL        : false,
})

const produceRsqlQuery = createSelector([
  (state) => getFullFilterFieldsConf(state, customModuleConfig.getAllFieldsMetadata, customModuleConfig.routing.list.filter),
  (state, query) => query || {},
], (fullFilterFieldsConf, query) => {
  if (isObject(get(query, `query`, ``))) {
    const querySearch = filtersConfig.valuesToQuery(query.query, fullFilterFieldsConf)
    return has(querySearch, `query`)
      ? {
        ...query,
        ...querySearch,
      }
      : omit(query, `query`)
  }
  return query
})

const getFilter = createSelector([
  (state) => produceRsqlQuery(state, getComputedQuery(state, ISSUES_SCHEMA_NAME))?.query,
  (state) => getCheckedRows(state, ISSUES_SCHEMA_NAME),
], (query, checkedRows) => {
  if (R.length(checkedRows) && query) {
    return `${query};id=in=(${checkedRows.toString()})`
  }
  if (R.length(checkedRows)) {
    return `id=in=(${checkedRows.toString()})`
  }
  return query
})

const Summary = ({ data: { summary } }) => <div className="summary-view">{summary}</div>

const customModuleConfig = {
  ...defaultModuleConfig,
  getGridConfig,
  shouldRequestCount : false,
  getSortQueryParam  : undefined,
  parseSortQueryParam: undefined,
  getViewConfig,
  getFormConfig,
  filterFormFields,
  defaultViewList    : issuesViewList,
  defaultFormListEdit,
  defaultFormList,
  routing            : {
    ...defaultModuleConfig.routing,
    list: {
      ...defaultModuleConfig.routing.list,
      getAllColumns,
      useQuickView: true,
      messageOnZeroCount: `Найдено 0 записей`,
      filter      : {
        ...defaultModuleConfig.routing.list.filter,
        getAllFilters,
        getFilterConfig,
        defaultFilterList,
        ...filtersConfig,
      },
      defaultFilter: {
        ...defaultFilterConfig,
      },
      exportToFileConfig: {
        ...defaultModuleConfig.routing.list.exportToFileConfig,
        getFilter,
      },
      toolbarButtons: [
        {
          id       : `create`,
          component: CreateButton,
        },
        EditButtonConfig,
        defaultModuleConfig.routing.list.toolbarButtons[2],
      ],
    },
    read: {
      ...defaultModuleConfig.routing.read,
      rightWidgetsConfiguration,
      rightWidgets: [
        ...defaultModuleConfig.routing.read.rightWidgets,
      ],
      toolbarComponents: [
        ReadEditButtonConfig,
        defaultModuleConfig.routing.read.toolbarComponents[1],
        defaultModuleConfig.routing.read.toolbarComponents[2],
        defaultModuleConfig.routing.read.toolbarComponents[3],
        defaultModuleConfig.routing.read.toolbarComponents[4],
        {
          id       : `summary`,
          component: Summary,
        },
      ],
    },
    create: {
      ...defaultModuleConfig.routing.create,
      component         : CRUDform,
      title             : `Создать заявку`,
      extraClassNameForm: `esuz-create-form`,
      submitButtonText  : `Создать`,
      getSuccessMessage : (id) => `Заявка #${id} добавлена`,
      getFailMessage    : getCreateFailMessage,
      // onFormInit        : (dispatch, formData) => {}
    },
    edit: {
      ...defaultModuleConfig.routing.edit,
      component         : CRUDform,
      extraClassNameForm: `esuz-create-form`,
      title             : ``,
      submitButtonText  : `Сохранить`,
    },
  },
}

// eslint-disable-next-line max-len
const withRSQL = (actionCreator) => (query) => (dispatch, getState) => (
  dispatch(actionCreator(produceRsqlQuery(getState(), query)))
)

const rsqlIssuesKeyGen = (state, query) => qs.stringify(produceRsqlQuery(state, query))

const moduleCrudConfig = defaulCrudConfigMaker(
  {
    ...customModuleConfig,
    keygenForApiTransport: rsqlIssuesKeyGen,
    apiActions           : {
      ...issuesApiActions,
      fetch: withRSQL(baseActions.fetch),
    },
  },
  CRUD_PATH,
  URL,
)

// console.log(`moduleCrudConfig`,moduleCrudConfig)

export default {
  ...mapissuesModule,
  config: {
    ...mapissuesModule.config,
    moduleCrudConfig,
    CRUDRoute: () => mapissuesModule.config.CRUDRoute(moduleCrudConfig),
  },
  reducers: {
    ...mapissuesModule.reducers,
    ...mapissuesReducers,
  },
}
